var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "wave",
    style: {
      transform: "rotate(0deg)",
      transition: "0.3s"
    },
    viewBox: "0 0 1440 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient-0",
    x1: 0,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(243, 106, 62, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 179, 11, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      transform: "translate(0, 0px)",
      opacity: 1
    },
    fill: "url(#sw-gradient-0)",
    d: "M0,90L60,115C120,140,240,190,360,220C480,250,600,260,720,220C840,180,960,90,1080,90C1200,90,1320,180,1440,225C1560,270,1680,270,1800,265C1920,260,2040,250,2160,210C2280,170,2400,100,2520,80C2640,60,2760,90,2880,85C3000,80,3120,40,3240,50C3360,60,3480,120,3600,135C3720,150,3840,120,3960,110C4080,100,4200,110,4320,95C4440,80,4560,40,4680,25C4800,10,4920,20,5040,55C5160,90,5280,150,5400,185C5520,220,5640,230,5760,225C5880,220,6000,200,6120,190C6240,180,6360,180,6480,155C6600,130,6720,80,6840,80C6960,80,7080,130,7200,130C7320,130,7440,80,7560,75C7680,70,7800,110,7920,130C8040,150,8160,150,8280,145C8400,140,8520,130,8580,125L8640,120L8640,300L8580,300C8520,300,8400,300,8280,300C8160,300,8040,300,7920,300C7800,300,7680,300,7560,300C7440,300,7320,300,7200,300C7080,300,6960,300,6840,300C6720,300,6600,300,6480,300C6360,300,6240,300,6120,300C6000,300,5880,300,5760,300C5640,300,5520,300,5400,300C5280,300,5160,300,5040,300C4920,300,4800,300,4680,300C4560,300,4440,300,4320,300C4200,300,4080,300,3960,300C3840,300,3720,300,3600,300C3480,300,3360,300,3240,300C3120,300,3000,300,2880,300C2760,300,2640,300,2520,300C2400,300,2280,300,2160,300C2040,300,1920,300,1800,300C1680,300,1560,300,1440,300C1320,300,1200,300,1080,300C960,300,840,300,720,300C600,300,480,300,360,300C240,300,120,300,60,300L0,300Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.5416ebe68903f60c8cbee7782439e7ac.svg";
export { ForwardRef as ReactComponent };